import { NavLink, useLocation, useNavigate } from "react-router-dom";

//Okta related packages

import UserInfo from "../../components/user-info/user-info";
import { useDispatch } from "react-redux";
import usePracticeHook from "../../hooks/practice";
import userRoles from "../../hooks/role";
import serverEnv from "../../hooks/serverEnvironment";
import { logout } from "../../features/auth/authSlice";
// import { LOGOUT } from "../../constants/actionsTypes";

// SVG Icons
import Dashboard from "../../assets/svg/Sidebar/Dashboard.svg";
import Calendar from "../../assets/svg/Sidebar/Schedule.svg";
import Patients from "../../assets/svg/Sidebar/Patients.svg";
import Handovers from "../../assets/svg/Sidebar/Handovers.svg";
import Support from "../../assets/svg/Sidebar/Support.svg";
import Kompliwise from "../../assets/svg/Sidebar/Kompliwise.svg";
import Podiatry from "../../assets/svg/Sidebar/Podiatry.svg";
import Dietetics from "../../assets/svg/Sidebar/Dietetics.svg";
import ProgressNotes from "../../assets/svg/Sidebar/ProgressNotes.svg";
import Assessment from "../../assets/svg/Sidebar/Assessments.svg";
import CarePlans from "../../assets/svg/Sidebar/Careplans.svg";
import Account from "../../assets/svg/Sidebar/Account.svg";
import Carehome from "../../assets/svg/Sidebar/Carehome.svg";
import Subscribe from "../../assets/svg/Sidebar/Subscription.svg";

// Font Awesome Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCircle } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fab, far, fas);

const SideBar = ({ setIsNavClosed, saved, setSaved }) => {
  const authState = JSON.parse(localStorage.getItem("auth0-token-storage"));
  const userClaims = JSON.parse(localStorage.getItem("user-claims"));
  const clientApp = userClaims && userClaims?.clientApp;
  const isHapiPartnerUser =
    clientApp && clientApp.some((data) => data.appName === "HAPIPARTNERS");
  const isApprovedUser = userClaims?.isActive;
  const kompliwiseURL = process.env.REACT_APP_KOMPLIWISE_URL;
  const hapiaCDMURL = process.env.REACT_APP_HAPIA_CDM_URL || "";
  const { hasPhysioPractice, hasDiatecianPractice } = usePracticeHook();
  const {
    adminRole,
    clinicalManagerRole,
    facilityManagerRole,
    careHomeManagerRole,
    customerSupportRole,
    hrManagerRole,
  } = userRoles();
  const { isAuServer } = serverEnv();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  const handleChangeURL = (e, url) => {
    e.preventDefault();
    if (!saved) {
      if (
        !window.confirm(
          "Are you sure you want to leave this page? Unsaved changes will be discarded"
        )
      )
        return;
    }
    setSaved(true);
    navigate(url);

    // reload page if your last route is /login
    if (location.pathname.includes("/login")) {
      window.location.reload();
    }
  };

  return (
    <div style={{ marginBottom: "100px" }}>
      <button
        className="border border-0 rounded-pill bg-light text-dark pt-2 mt-1"
        onClick={() => setIsNavClosed(true)}
      >
        <i className="far fa-times-circle h4"></i>
        <span className="orange-1 font-weight-bold ml-1 align-top">Close</span>
      </button>
      <UserInfo />

      <div className="mt-5 d-flex flex-column vertical-center pl-5 navbar-nav align-text-sm-start">
        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/landing-page") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to={"/landing-page"}
              onClick={(e) => handleChangeURL(e, "/landing-page")}
            >
              <img src={Dashboard} alt="Dashboard" className="svg-sidebar" />
              DASHBOARD
            </NavLink>
          </li>
        )}

        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/schedules") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/schedules"
              onClick={(e) => handleChangeURL(e, "/schedules")}
            >
              <img src={Calendar} alt="Schedule" className="svg-sidebar" />
              SCHEDULE
            </NavLink>
          </li>
        )}
        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <>
            {adminRole ||
            facilityManagerRole ||
            clinicalManagerRole ||
            careHomeManagerRole ? (
              <>
                <li
                  className={`nav-item ${
                    location.pathname.indexOf("/facilities") >= 0
                      ? "active"
                      : ""
                  }`}
                >
                  <a
                    className="nav-link sidebar-link d-flex"
                    href="#facilityDropdown"
                    data-toggle="collapse"
                  >
                    <FontAwesomeIcon
                      icon={["fa", "hospital"]}
                      style={{
                        height: "20px",
                        width: "20px",
                        marginRight: "15px",
                        marginTop: "1px",
                      }}
                    />
                    FACILITIES
                  </a>
                </li>
                <div
                  className={`collapse ${
                    location.pathname.indexOf("/facilities") >= 0 ? "show" : ""
                  }`}
                  id="facilityDropdown"
                >
                  {/* Podiatrist */}
                  <li
                    className={
                      "nav-item pl-2" +
                      (location.pathname.indexOf("/facilities/podiatry") >= 0
                        ? " active"
                        : "")
                    }
                  >
                    <a
                      className="nav-link sidebar-link d-flex"
                      href="#podiatryDropdown"
                      data-toggle="collapse"
                    >
                      <img
                        src={Podiatry}
                        alt="Podiatry"
                        className="svg-sidebar"
                        style={{ color: "black" }}
                      />
                      PODIATRY
                    </a>
                  </li>
                  <div
                    className={`collapse${
                      location.pathname.indexOf("/facilities/podiatry") >= 0
                        ? "show"
                        : ""
                    }`}
                    id="podiatryDropdown"
                  >
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/podiatry/progressNotes"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/podiatry/progressNotes?page=1&podiatrist=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/podiatry/progressNotes?page=1&podiatrist=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={ProgressNotes}
                          alt="Progress-Notes"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        PROGRESS NOTES
                      </NavLink>
                    </li>
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/podiatry/assessments"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/podiatry/assessments?page=1&podiatrist=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/podiatry/assessments?page=1&podiatrist=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={Assessment}
                          alt="Assessment"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        ASSESSMENTS
                      </NavLink>
                    </li>
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/podiatry/carePlans"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/podiatry/carePlans?page=1&podiatrist=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/podiatry/carePlans?page=1&podiatrist=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={CarePlans}
                          alt="CarePlans"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        CARE PLANS
                      </NavLink>
                    </li>
                  </div>
                  {/* Physiotherapy */}
                  <li
                    className={
                      "nav-item pl-2" +
                      (location.pathname.indexOf("/facilities/physiotherapy") >=
                      0
                        ? " active"
                        : "")
                    }
                  >
                    <a
                      className="nav-link sidebar-link d-flex"
                      href="#physiotherapyDropdown"
                      data-toggle="collapse"
                    >
                      <FontAwesomeIcon
                        icon={["fa", "user"]}
                        style={{
                          height: "20px",
                          width: "20px",
                          marginRight: "15px",
                          marginTop: "1px",
                        }}
                      />
                      PHYSIOTHERAPY
                    </a>
                  </li>
                  <div
                    className={`collapse ${
                      location.pathname.indexOf("/facilities/physiotherapy") >=
                      0
                        ? "show"
                        : ""
                    }`}
                    id="physiotherapyDropdown"
                  >
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/physiotherapy/progressNotes"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/physiotherapy/progressNotes?page=1&physiotherapist=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/physiotherapy/progressNotes?page=1&physiotherapist=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={ProgressNotes}
                          alt="Progress-Notes"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        PROGRESS NOTES
                      </NavLink>
                    </li>
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/physiotherapy/assessments"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/physiotherapy/assessments?page=1&physiotherapist=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/physiotherapy/assessments?page=1&physiotherapist=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={Assessment}
                          alt="Assessment"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        ASSESSMENTS
                      </NavLink>
                    </li>
                  </div>
                  {/* Dietetics */}
                  <li
                    className={
                      "nav-item pl-2" +
                      (location.pathname.indexOf("/facilities/dietetics") >= 0
                        ? " active"
                        : "")
                    }
                  >
                    <a
                      className="nav-link sidebar-link d-flex"
                      href="#dieteticsDropdown"
                      data-toggle="collapse"
                    >
                      <img
                        src={Dietetics}
                        alt="dietetics"
                        className="svg-sidebar"
                        style={{ color: "black", weight: "40px" }}
                      />
                      DIETETICS
                    </a>
                  </li>
                  <div
                    className={`collapse ${
                      location.pathname.indexOf("/facilities/dietetics") >= 0
                        ? "show"
                        : ""
                    }`}
                    id="dieteticsDropdown"
                  >
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/dietetics/progressNotes"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/dietetics/progressNotes?page=1&dietitian=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/dietetics/progressNotes?page=1&dietitian=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={ProgressNotes}
                          alt="Progress-Notes"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        PROGRESS NOTES
                      </NavLink>
                    </li>
                    <li
                      className={
                        "nav-item pl-4" +
                        (location.pathname.indexOf(
                          "/facilities/dietetics/assessments"
                        ) >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex align-items-center"
                        exact
                        to={
                          "/facilities/dietetics/assessments?page=1&dietitian=null&facility=null"
                        }
                        onClick={(e) =>
                          handleChangeURL(
                            e,
                            "/facilities/dietetics/assessments?page=1&dietitian=null&facility=null"
                          )
                        }
                      >
                        <img
                          src={Assessment}
                          alt="Assessment"
                          className="svg-sidebar"
                          style={{ color: "black" }}
                        />
                        ASSESSMENTS
                      </NavLink>
                    </li>
                  </div>
                </div>
              </>
            ) : null}
          </>
        )}

        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/patients") >= 0 ? " active" : "")
            }
          >
            {hasPhysioPractice ? (
              <NavLink
                className="nav-link sidebar-link d-flex"
                exact
                to="/patients?page=1&patientId=null&tab=2&facility=null&filter=all&ward=null&funding=null&inactiveResident=false"
                onClick={(e) =>
                  handleChangeURL(
                    e,
                    "/patients?page=1&patientId=null&tab=2&facility=null&filter=all&ward=null&funding=null&inactiveResident=false"
                  )
                }
              >
                <img src={Patients} alt="Dashboard" className="svg-sidebar" />
                PATIENTS
              </NavLink>
            ) : (
              <NavLink
                className="nav-link sidebar-link d-flex"
                exact
                to="/patients?page=1&patientId=null&tab=1&facility=null&filter=all&ward=null&funding=null&inactiveResident=false"
                onClick={(e) =>
                  handleChangeURL(
                    e,
                    "/patients?page=1&patientId=null&tab=1&facility=null&filter=all&ward=null&funding=null&inactiveResident=false"
                  )
                }
              >
                <img src={Patients} alt="Dashboard" className="svg-sidebar" />
                PATIENTS
              </NavLink>
            )}
          </li>
        )}
        {!isHapiPartnerUser ||
        !isApprovedUser ||
        hrManagerRole ||
        careHomeManagerRole ||
        adminRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/tasks") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to={"/tasks"}
              onClick={(e) => handleChangeURL(e, "/tasks")}
            >
              <FontAwesomeIcon
                icon={["fa", "clipboard-list"]}
                style={{
                  height: "20px",
                  width: "20px",
                  marginRight: "15px",
                  marginTop: "1px",
                }}
              />
              TASKS
            </NavLink>
          </li>
        )}
        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/chat") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to={"/chat?channelId=null"}
              onClick={(e) => handleChangeURL(e, "/chat?channelId=null")}
            >
              <FontAwesomeIcon
                icon={["fa", "comments"]}
                style={{
                  height: "20px",
                  width: "20px",
                  marginRight: "15px",
                  marginTop: "1px",
                }}
              />
              CHAT
            </NavLink>
          </li>
        )}

        {/* <li
          className={
            "nav-item" +
            (location.pathname.indexOf("/users") >= 0 ? " active" : "")
          }
        >
          <NavLink
            className="nav-link sidebar-link"
            exact
            to="/users"
            onClick={(e) => handleChangeURL(e, "/users")}
          >
            <FontAwesomeIcon
              icon={["fa", "users"]}
              className="mr-3 nav-spacing"
            />
            USERS
          </NavLink>
        </li> */}

        {!isHapiPartnerUser ||
        !isApprovedUser ||
        hrManagerRole ? null : hasPhysioPractice ||
          hasDiatecianPractice ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/handovers") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to={`/handovers?page=1&facility=null&fromDate=null&toDate=null`}
              onClick={(e) =>
                handleChangeURL(
                  e,
                  "/handovers?page=1&facility=null&fromDate=null&toDate=null"
                )
              }
            >
              <img src={Handovers} alt="Schedule" className="svg-sidebar" />
              HANDOVER
            </NavLink>
          </li>
        )}

        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/support") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/support/contact"
              onClick={(e) => handleChangeURL(e, "/support/contact")}
            >
              <img src={Support} alt="Support" className="svg-sidebar" />
              SUPPORT
            </NavLink>
          </li>
        )}

        {!isHapiPartnerUser ||
        !isApprovedUser ||
        hrManagerRole ||
        careHomeManagerRole ||
        adminRole ? null : (
          <li className="nav-item">
            <a
              className="nav-link sidebar-link d-flex"
              href={`${kompliwiseURL}/app/validate?q=${authState.access_token}`}
              target="_blank"
            >
              <img src={Kompliwise} alt="Kompliwise" className="svg-sidebar" />
              KOMPLIWISE
            </a>
          </li>
        )}

        {!isHapiPartnerUser || !isApprovedUser || hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/notifications") >= 0
                ? " active"
                : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/notifications?page=1"
              onClick={(e) => handleChangeURL(e, "/notifications?page=1")}
            >
              <FontAwesomeIcon
                icon={["fa", "bell"]}
                style={{
                  height: "20px",
                  width: "20px",
                  marginRight: "15px",
                  marginTop: "1px",
                }}
              />
              NOTIFICATIONS
            </NavLink>
          </li>
        )}

        {!hrManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/account") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/account/manage"
              onClick={(e) => handleChangeURL(e, "/account/manage")}
            >
              <img
                src={Account}
                alt="admin"
                style={{
                  height: "22px",
                  width: "22px",
                  marginRight: "15px",
                  marginTop: "1px",
                }}
              />
              MANAGE ACCOUNTS
            </NavLink>
          </li>
        )}

        {/* {!adminRole ? null : (
            <>
              <li
                className={
                  "nav-item" +
                  (location.pathname.indexOf("/account") >= 0 ? " active" : "")
                }
              >
                <a
                  className="nav-link sidebar-link d-flex"
                  href="#accountDropdown"
                  data-toggle="collapse"
                >
                  <FontAwesomeIcon
                    icon={["fa", "user"]}
                    style={{
                      height: "20px",
                      width: "20px",
                      marginRight: "15px",
                      marginTop: "1px",
                    }}
                  />
                  ACCOUNT
                </a>
              </li>
              <div
                className={`collapse ${
                  location.pathname.indexOf("/account") >= 0 ? "show" : ""
                }`}
                id="accountDropdown"
              >
                <li
                  className={
                    "nav-item pl-2" +
                    (location.pathname.indexOf("/account/register") >= 0
                      ? " active"
                      : "")
                  }
                >
                  <NavLink
                    className="nav-link sidebar-link d-flex"
                    exact
                    to={"/account/register"}
                    onClick={(e) => handleChangeURL(e, "/account/register")}
                  >
                    <img src={Account} alt="account" className="svg-sidebar" />
                    REGISTER
                  </NavLink>
                </li>
                <li
                      className={
                        "nav-item pl-2" +
                        (location.pathname.indexOf("/account/lists") >= 0
                          ? " active"
                          : "")
                      }
                    >
                      <NavLink
                        className="nav-link sidebar-link d-flex"
                        exact
                        to={"/account/lists?page=1"}
                        onClick={(e) =>
                          handleChangeURL(e, "/account/lists?page=1")
                        }
                      >
                        <img
                          src={Account}
                          alt="account"
                          className="svg-sidebar"
                        />
                        ACCOUNT LISTS
                      </NavLink>
                    </li>
              </div>
            </>
          )} */}
        <li
          className={
            "nav-item" +
            (location.pathname.indexOf("/settings") >= 0 ? " active" : "")
          }
        >
          <NavLink
            className="nav-link sidebar-link d-flex"
            exact
            to="/settings"
            onClick={(e) => handleChangeURL(e, "/settings")}
          >
            <FontAwesomeIcon
              icon={["fa", "wrench"]}
              style={{
                height: "20px",
                width: "20px",
                marginRight: "15px",
                marginTop: "1px",
              }}
            />
            SETTINGS
          </NavLink>
        </li>

        {/* <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/profile/edit") >= 0 ? " active" : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/profile/edit"
              onClick={(e) => handleChangeURL(e, "/profile/edit")}
            >
              <span
                className="fa-layers fa-fw"
                style={{
                  marginRight: "15px",
                }}
              >
                <FontAwesomeIcon
                  icon={["fa", "user"]}
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
                <FontAwesomeIcon
                  icon={faCircle}
                  transform="shrink-4 right-6.5 down-6.5"
                />
                <FontAwesomeIcon
                  icon={["fa", "wrench"]}
                  transform="shrink-7 right-7 down-7"
                  style={{ color: "white" }}
                />
              </span>
              <span style={{ fontSize: "15px" }}>PROFILE</span>
            </NavLink>
          </li> */}

        {!isHapiPartnerUser ||
        !isApprovedUser ? null : !careHomeManagerRole ? null : (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/subscriptions") >= 0
                ? " active"
                : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/subscriptions"
              onClick={(e) => handleChangeURL(e, "/subscriptions")}
            >
              <img src={Subscribe} alt="subscription" className="svg-sidebar" />
              SUBSCRIPTIONS
            </NavLink>
          </li>
        )}

        {!isHapiPartnerUser || !isApprovedUser ? null : !adminRole ? null : (
          <>
            <li
              className={
                "nav-item" +
                (location.pathname.indexOf("/admin") >= 0 ? " active" : "")
              }
            >
              <a
                className="nav-link sidebar-link d-flex"
                href="#adminDropdown"
                data-toggle="collapse"
              >
                <img
                  src={Account}
                  alt="admin"
                  style={{
                    height: "22px",
                    width: "22px",
                    marginRight: "15px",
                    marginTop: "1px",
                  }}
                />
                ADMIN
              </a>
            </li>
            <div
              className={`collapse ${
                location.pathname.indexOf("/admin") >= 0 ? "show" : ""
              }`}
              id="adminDropdown"
            >
              <li
                className={
                  "nav-item pl-2" +
                  (location.pathname.indexOf("/admin/register-carehome") >= 0
                    ? " active"
                    : "")
                }
              >
                <NavLink
                  className="nav-link sidebar-link d-flex align-items-center"
                  exact
                  to={"/admin/register-carehome"}
                  onClick={(e) =>
                    handleChangeURL(e, "/admin/register-carehome")
                  }
                >
                  <img src={Carehome} alt="admin" className="svg-sidebar" />
                  <span style={{ fontSize: "15px" }}>REGISTER CAREHOME</span>
                </NavLink>
              </li>
              <li
                className={
                  "nav-item pl-2" +
                  (location.pathname.indexOf("/admin/register-employee") >= 0
                    ? " active"
                    : "")
                }
              >
                <NavLink
                  className="nav-link sidebar-link d-flex align-items-center"
                  exact
                  to={"/admin/register-employee"}
                  onClick={(e) =>
                    handleChangeURL(e, "/admin/register-employee")
                  }
                >
                  <FontAwesomeIcon
                    icon={["fas", "user-plus"]}
                    style={{
                      height: "20px",
                      width: "20px",
                      marginRight: "15px",
                      marginTop: "1px",
                    }}
                  />
                  <span style={{ fontSize: "15px" }}>REGISTER EMPLOYEE</span>
                </NavLink>
              </li>
              <li
                className={
                  "nav-item pl-2" +
                  (location.pathname.indexOf("/admin/register-facility") >= 0
                    ? " active"
                    : "")
                }
              >
                <NavLink
                  className="nav-link sidebar-link d-flex align-items-center"
                  exact
                  to={"/admin/register-facility"}
                  onClick={(e) =>
                    handleChangeURL(e, "/admin/register-facility")
                  }
                >
                  <span
                    className="fa-layers fa-fw"
                    style={{
                      marginRight: "15px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["fa", "hospital"]}
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faCircle}
                      transform="shrink-4 right-6.5 down-6.5"
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      transform="shrink-7 right-7 down-7"
                      style={{ color: "white" }}
                    />
                  </span>
                  <span style={{ fontSize: "15px" }}>REGISTER FACILITY</span>
                </NavLink>
              </li>
            </div>
          </>
        )}

        {!isHapiPartnerUser ||
        !isApprovedUser ||
        isAuServer ? null : adminRole || customerSupportRole ? (
          <li
            className={
              "nav-item" +
              (location.pathname.indexOf("/practitioners") >= 0
                ? " active"
                : "")
            }
          >
            <NavLink
              className="nav-link sidebar-link d-flex"
              exact
              to="/practitioners?page=1"
              onClick={(e) => handleChangeURL(e, "/practitioners?page=1")}
            >
              <FontAwesomeIcon
                icon={["fa", "user-nurse"]}
                style={{
                  height: "20px",
                  width: "20px",
                  marginRight: "15px",
                  marginTop: "1px",
                }}
              />
              PRACTITIONERS
            </NavLink>
          </li>
        ) : null}
        {/* {!isHapiPartnerUser ||
        !isApprovedUser ||
        hrManagerRole ||
        !isAuServer ? null : (
          <li className="nav-item">
            <a
              className="nav-link sidebar-link d-flex"
              href={`${hapiaCDMURL}?q=${authState.access_token}&page=cdm`}
              target="_blank"
            >
              <FontAwesomeIcon
                icon={["fa", "paper-plane"]}
                style={{
                  height: "20px",
                  width: "20px",
                  marginRight: "15px",
                  marginTop: "1px",
                }}
              />
              CDM
            </a>
          </li>
        )} */}

        <br />
        {userClaims && authState ? (
          <li className="nav-item mt-3 mb-5 mb-md-1 cursor-pointer">
            <p className="nav-link sidebar-link" onClick={handleLogout}>
              <FontAwesomeIcon
                icon={["fa", "sign-out-alt"]}
                className="mr-3 nav-spacing"
              />
              LOG OUT
            </p>
          </li>
        ) : (
          <li className="nav-item mt-3 mb-5 mb-md-1">
            <NavLink className="nav-link sidebar-link" exact to="/login">
              <FontAwesomeIcon
                icon={["fa", "sign-in-alt"]}
                className="mr-3 nav-spacing"
              />
              LOG IN
            </NavLink>
          </li>
        )}
      </div>
    </div>
  );
};

export default SideBar;
